import { fetchEndpoint } from '../server/network'

export const categoryList = (shop, category) =>
	fetchEndpoint('/v2/ecapi.category.list', 'POST', {
		shop: shop,
		category: category
	})



// WEBPACK FOOTER //
// ./src/api/category.js